import React from "react";
import { Link } from "react-router-dom";
import mainLogo from "../../assets/images/tutify-white-logo.png";
import homeLogo from "../../assets/images/main_logo.png";
import collapsedLogo from "../../assets/images/simple_logo.png";

const HeaderLogo = ({ collapsed, isHome = true }) => {
  return collapsed === undefined ? (
    <Link className="navbar-brand" to="/">
      <img
        style={{ height: "32px", marginTop: "-8px" }}
        src={isHome ? homeLogo : mainLogo}
        alt="Tutify Logo"
      />
    </Link>
  ) : (
    <Link
      className="navbar-brand"
      to="/"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // height: 64,
        textDecoration: "none",
      }}
    >
      {collapsed ? (
        <img
          style={{
            height: "32px",
            marginTop: "-12px",
            transition: "opacity 0.3s ease",
          }}
          src={collapsedLogo}
          alt="Tutify Logo"
        />
      ) : (
        <img
          style={{
            height: "35px",
            transition: "opacity 0.3s ease",
          }}
          src={mainLogo}
          alt="Tutify Logo"
        />
      )}
    </Link>
  );
};

export default HeaderLogo;
